/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type CollegamentoIstanzaDettaglioDTODirezione =
  (typeof CollegamentoIstanzaDettaglioDTODirezione)[keyof typeof CollegamentoIstanzaDettaglioDTODirezione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollegamentoIstanzaDettaglioDTODirezione = {
  ENTRATA: 'ENTRATA',
  USCITA: 'USCITA',
} as const;
